(function($) {
    var numSlick = 0;
    var $sliderCTA = $('.slider-resources');
    // Slider with CTA cards
    $sliderCTA.each(function() {
        numSlick++;
        $(this).addClass('slider-resources-' + numSlick).slick({
            accessibility: false,
            arrows: false,
            dots: true,
            infinite: false,
            slide: '.slider-item',
            slidesToScroll: 1,
            slidesToShow: 4,
            responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1.1,
                    }
                }
            ]
        });
    });
})(jQuery);